<template>
  <Layout >
    <router-view></router-view>
  </Layout>
</template>

<script setup>
import Layout from './layout'
</script>